import { Card, Col, Form, Input, InputNumber, Row, TreeSelect } from "antd";
import React from "react";

import useDetailsFormPresenter from "@Totum/QuestionnaireBuilder/Presentation//hooks/useDetailsFormPresenter";

const DetailsForm = () => {
    const { handlers, uiModel } = useDetailsFormPresenter();

    return (
        <div className="questionnaire-designer designer">
            <Card className="newUI-raised">
                <Form
                    form={uiModel.form}
                    name="questionnaire-edit"
                    className="questionnaire-edit-form designer-edit-form"
                    layout="vertical"
                    onValuesChange={handlers.handleValuesChange}
                >
                    <Row gutter={[8, 16]}>
                        <Col md={6} xs={12}>
                            <Form.Item
                                name="title"
                                label="Title"
                                rules={[{ required: true, message: "Please give the questionnaire a title" }]}
                            >
                                <Input placeholder="Questionnaire title" />
                            </Form.Item>
                        </Col>
                        <Col md={8} xs={12}>
                            <Form.Item
                                name="description"
                                label="Description"
                                rules={[{ required: true, message: "Please give the questionnaire a description" }]}
                            >
                                <Input placeholder="Add a description" />
                            </Form.Item>
                        </Col>
                        <Col md={6} xs={12}>
                            <Form.Item
                                className="activity-select"
                                label="Activities"
                                name="associationCollection"
                                rules={[{ required: true, message: "Please select an activity" }]}
                            >
                                <TreeSelect
                                    placeholder="Select or type..."
                                    treeData={uiModel.activityCategoriesTree}
                                    onSelect={handlers.handleSelect}
                                    onDeselect={handlers.handleDeselect}
                                    treeCheckable={true}
                                />
                            </Form.Item>
                        </Col>

                        <Col md={4} xs={12}>
                            <Form.Item
                                name="points"
                                label="Points"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please give number of points to this questionnaire",
                                    },
                                ]}
                            >
                                <InputNumber
                                    placeholder="Add CME Points"
                                    style={{ width: "100%" }}
                                    disabled={uiModel.questionnaire.isPublished}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default DetailsForm;
